exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".input-text{background-color:#e5e6e6;padding-left:20px;color:#879393;width:470px;height:40px;box-shadow:inset 3px 2px 0 0 #d9dada;border-style:none;border-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d6d78c9e","scoped":false,"hasInlineConfig":true}!./src/components/input-text/input-text.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-d6d78c9e","scoped":false,"hasInlineConfig":true}!./src/components/input-text/input-text.css
// module chunks = index